import '../WorkflowEditor.css';

export default function PreviewSection({ config, allFields, allFlags, allTemplates }) {
  const groups = config.extraction || [];
  const categories = config.red_flags || [];
  const templateRefs = config.document_refs || [];

  const resolveField = (id) => allFields.find((f) => f.id === id);
  const resolveFlag = (id) => allFlags.find((f) => f.id === id);
  const resolveTemplate = (id) => allTemplates.find((t) => t.id === id);

  const totalFields = groups.reduce((sum, g) => sum + (g.field_refs || []).length, 0);
  const totalFlags = categories.reduce((sum, c) => sum + (c.flag_refs || []).length, 0);

  return (
    <div className="wfe-preview">
      {/* System Instruction */}
      <div className="wfe-section-card">
        <div className="wfe-section-title">System Instruction</div>
        <pre className="wfe-preview-prompt">{config.system_instruction || '(none)'}</pre>
      </div>

      {/* Extraction */}
      <div className="wfe-section-card">
        <div className="wfe-section-title">
          Extraction &mdash; {groups.length} groups, {totalFields} fields
        </div>
        {groups.length === 0 ? (
          <p className="wfe-preview-empty">No extraction groups configured.</p>
        ) : (
          groups.map((group, gi) => (
            <div key={group.group_name} className="wfe-preview-group">
              <div className="wfe-preview-group-header">
                <span className="wfe-preview-order">{group.order || gi + 1}</span>
                <span className="wfe-preview-group-name">{group.group_name}</span>
                <span className="wfe-preview-count">{(group.field_refs || []).length} fields</span>
              </div>
              <div className="wfe-preview-fields">
                {(group.field_refs || []).map((fieldId) => {
                  const field = resolveField(fieldId);
                  if (!field) return (
                    <div key={fieldId} className="wfe-preview-field missing">
                      <span className="wfe-preview-field-name">Missing: {fieldId}</span>
                    </div>
                  );
                  return (
                    <div key={fieldId} className="wfe-preview-field">
                      <span className="wfe-preview-field-name">
                        {field.name}
                        {field.required && <span className="wfe-required-badge" style={{ marginLeft: 8 }}>Required</span>}
                      </span>
                      {field.question && (
                        <span className="wfe-preview-field-question">{field.question}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Red Flags */}
      <div className="wfe-section-card">
        <div className="wfe-section-title">
          Red Flags &mdash; {categories.length} categories, {totalFlags} flags
        </div>
        {categories.length === 0 ? (
          <p className="wfe-preview-empty">No red flag categories configured.</p>
        ) : (
          categories.map((cat, ci) => (
            <div key={cat.category_name} className="wfe-preview-group">
              <div className="wfe-preview-group-header">
                <span className="wfe-preview-order">{cat.order || ci + 1}</span>
                <span className="wfe-preview-group-name">{cat.category_name}</span>
                <span className="wfe-preview-count">{(cat.flag_refs || []).length} flags</span>
              </div>
              <div className="wfe-preview-fields">
                {(cat.flag_refs || []).map((flagId) => {
                  const flag = resolveFlag(flagId);
                  if (!flag) return (
                    <div key={flagId} className="wfe-preview-field missing">
                      <span className="wfe-preview-field-name">Missing: {flagId}</span>
                    </div>
                  );
                  return (
                    <div key={flagId} className="wfe-preview-field">
                      <span className="wfe-preview-field-name">{flag.name}</span>
                      {flag.description && (
                        <span className="wfe-preview-field-question">{flag.description}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Document Templates */}
      <div className="wfe-section-card">
        <div className="wfe-section-title">
          Document Templates &mdash; {templateRefs.length} templates
        </div>
        {templateRefs.length === 0 ? (
          <p className="wfe-preview-empty">No document templates configured.</p>
        ) : (
          templateRefs.map((templateId) => {
            const tmpl = resolveTemplate(templateId);
            if (!tmpl) return (
              <div key={templateId} className="wfe-preview-template">
                <div className="wfe-preview-template-name" style={{ color: '#DC2626' }}>
                  Missing: {templateId}
                </div>
              </div>
            );
            return (
              <div key={templateId} className="wfe-preview-template">
                <div className="wfe-preview-template-header">
                  <span className="wfe-preview-template-name">{tmpl.name}</span>
                  <span className={`wfe-template-badge ${tmpl.active !== false ? 'active' : 'inactive'}`}>
                    {tmpl.active !== false ? 'Active' : 'Inactive'}
                  </span>
                </div>
                {tmpl.system_prompt && (
                  <div className="wfe-preview-prompt-section">
                    <label>System Prompt</label>
                    <pre className="wfe-preview-prompt">{tmpl.system_prompt}</pre>
                  </div>
                )}
                <div className="wfe-preview-prompt-section">
                  <label>Generation Prompt</label>
                  <pre className="wfe-preview-prompt">{tmpl.generation_prompt || '(none)'}</pre>
                </div>
                {tmpl.variables && tmpl.variables.length > 0 && (
                  <div className="wfe-preview-prompt-section">
                    <label>Variables</label>
                    <div className="wfe-var-list">
                      {tmpl.variables.map((v) => (
                        <span key={v} className="wfe-var-chip">{`{${v}}`}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
